import React, {useMemo} from 'react';
import {CardHeader, Card, CardHeaderToolbar, CardBody} from "../../../../../_metronic/_partials/controls";
import {InvoicesTable} from "./invoices-table/InvoicesTable";
import {useInvoicesUIContext} from "./InvoicesUIContext";
import { HasCreateAccess, IsSuperUser} from "../../../../../_metronic/_helpers/AccessControlHelpers";
import {useSelector} from "react-redux";
import {INVOICE_MODEL} from "../../../../../_metronic/_helpers/AppModels";

export function InvoicesCard(){
    
    const {user} = useSelector((state) => state.auth);
    
    const invoicesUiContext = useInvoicesUIContext();
    
    const invoicesUIProps = useMemo(() => (
        {
            newInvoiceButtonClick: invoicesUiContext.newInvoiceButtonClick
        }
    ), [invoicesUiContext])
    
    return(
        <Card>
            <CardHeader title={"لیست فاکتور ها"}>
                {(HasCreateAccess(user, INVOICE_MODEL) || IsSuperUser(user)) && (
                <CardHeaderToolbar>
                    <button
                        type={"button"}
                        className={"btn btn-primary"}
                    onClick={invoicesUIProps.newInvoiceButtonClick}>
                        ایجاد فاکتور
                    </button>
                    
                </CardHeaderToolbar>
                )}
            </CardHeader>
            <CardBody>
                
                <InvoicesTable/>
            </CardBody>
        </Card>
    )
    
    
}